// 2024 Frightened: Disadvantage on ability checks and attack rolls while the source of fear is within line of sight, and
// the creature can't willingly move closer to the source. Mindless Rage (Berserker 6) makes a raging Berserker immune.
import { getClassLevel } from './classIdentity.mjs';
import { hasBerserkerFrenzy } from './berserkerFrenzy.mjs';
import { isRageEffective } from './barbarianRage.mjs';
import { auraConditionImmunity } from './effects/auras.mjs';

export const FRIGHTENED = 'condition:frightened';
export const CHARMED = 'condition:charmed';

/** Mindless Rage: a Berserker of level 6+ is immune to Charmed and Frightened while their Rage is active. */
export const hasMindlessRage = (character, combat = {}, combatantId) =>
  hasBerserkerFrenzy(character) && getClassLevel(character, 'barbarian') >= 6 && isRageEffective(character, combat, combatantId);

/** The Frightened effects that apply to this creature now (none while Mindless Rage or Aura of Courage protects it). */
export const frightenedEffects = (character, combat = {}, combatantId) => {
  const id = String(combatantId ?? character?.characterId ?? character?._id ?? '');
  if (!id || (character && hasMindlessRage(character, combat, id)) || auraConditionImmunity(combat, id, 'frightened')) return [];
  return (combat?.activeEffects || []).filter((effect) => effect?.definitionId === FRIGHTENED && String(effect.targetCombatantId) === id);
};

/** The Charmed effects whose charmer is `charmerId`: this creature can't attack the charmer or target it with damaging
 * abilities or magical effects (2024). None while Mindless Rage or Aura of Devotion protects it. */
export const charmedByEffects = (character, combat = {}, combatantId, charmerId) => {
  const id = String(combatantId ?? character?.characterId ?? character?._id ?? '');
  if (!id || charmerId == null || (character && hasMindlessRage(character, combat, id)) || auraConditionImmunity(combat, id, 'charmed')) return [];
  return (combat?.activeEffects || []).filter((effect) => effect?.definitionId === CHARMED && String(effect.targetCombatantId) === id
    && String(effect.sourceCombatantId) === String(charmerId));
};
